import { Identifiable, List, Milestone, Tag } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { LinkedResource } from "../linkers/types";
import { formatDate } from "../utils/formatDate";
import { mapError } from "../utils/mapError";

function saveMilestone(httpClient: HttpClient) {
  return (
    list: Identifiable<List>,
    { endDate, ...milestone }: Milestone,
  ): Promise<Identifiable<Milestone>> =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<Milestone>>>({
        endpoint: `/milestones`,
        method: HttpMethods.POST,
        data: {
          name: milestone.name,
          description: milestone.description,
          state: milestone.state,
          tags: milestone.tags,
          ...(milestone.keyRank !== -1 && {
            keyRank: milestone.keyRank,
          }),
          ...(endDate && { endDate: formatDate(endDate) }),
          activity: `/activities/${list.uuid}`,
          ...(!!milestone.attributes && { attributes: milestone.attributes }),
        },
      })
      .then((milestone) => ({ ...milestone, list }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            emptyName: "emptyName",
            duplicateName: "duplicateName",
            endDateOutOfBound: "endDateOutOfBound",
            listNotFound: "listNotFound",
          }),
        ),
      );
}

export { saveMilestone };
